import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconWarning(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="18" height="18" rx="9" fill="currentColor" />
      <path d="M9 9.89999V4.49999" stroke="white" strokeWidth="2" />
      <path d="M9 13.5V11.7" stroke="white" strokeWidth="2" />
    </SVGIcon>
  );
}
